module.exports = __webpack_public_path__ + "assets/Other.d7308ba4f5561d46022db8319c51bd44.svg";